<template>
  <div class="manage">
    <div class="navbar">
      <span @click="routerTo('/pcpage/home')"> < 首页</span> / 图片故事 /
      {{ infoForm.category_name }}#{{ infoForm.topic_name }}
    </div>
    <div class="content">
      <div class="info">
        <div>
          <img
            :src="
              'https://collection2021-cos.chineseplus.net/' +
                infoForm.cover
            "
            alt=""
            class="cover"
          />
          <div class="right">
            <div class="title">
              {{ infoForm.title }}
            </div>
            <div class="user">
              {{ infoForm.user_name }}
            </div>
            <div class="country">
              {{ infoForm.cn }}
            </div>
            <div class="desc">
              {{ infoForm.desc }}
            </div>
          </div>
        </div>
      </div>
      <div class="wrapper">
        <div class="uploadCon" @click="add">
          <img src="../img/plus.png" alt="" />继续添加图片
        </div>
        <div class="list">
          <draggable
            v-model="infoForm.photo_list"
            chosen-class="chosen"
            handle=".cover"
            force-fallback="true"
            animation="500"
            @update="dataDragEnd"
          >
            <transition-group>
              <div
                v-for="item in infoForm.photo_list"
                :key="item.photo_id"
                class="photoCon"
                :class="{'isCover': item.is_cover}"
              >
                <img
                  :src="
                    'https://collection2021-cos.chineseplus.net/' +
                      item.photo_cover
                  "
                  alt=""
                  class="cover"
                />
                <div class="settingCon" @click="setCover(item)">
                  <img src="../img/m/seting_cover3.png" alt="" class="setting" >
                  设为封面

                </div>
                <div class="right">
                  <div class="title">
                    单图故事描述
                    <img src="../img/m/delete.png" alt="" class="delete" @click="deletePhoto(item.photo_id)">
                  </div>
                  <el-input
                    type="textarea"
                    placeholder="单图故事描述"
                    v-model="item.photo_desc"
                    @input="forceUpdate()"
                    maxlength="150"
                    resize="none"
                    :rows="8"
                    height="170px"
                    show-word-limit
                  >
                  </el-input>
                </div>
              </div>
            </transition-group>
          </draggable>
        </div>
      </div>
      <div class="submitCon">
        <div class="submit" @click="submit">
          提交
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      class="uploadDialog"
      :before-close="handleClose"
    >
      <template slot="title">
        <div class="title">单图上传</div>
      </template>
      <div class="content">
        <div class="uploadInfo">
          <el-form
            :model="singleForm"
            ref="singleForm"
            
            label-width="90px"
            class="ruleForm"
          >
            <label
              class="el-form-item__label"
              style="
                  width: 100px;
                  margin-top: -5px;
                  margin-bottom: 30px;
                  font-size: 14px;
                  padding-right: 20px;
                  color: #606266;
                "
              >选择图片</label
            >
            <el-upload
              class="upload-demo"
              ref="upload"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-change="picChange"
              :multiple="false"
              :limit="1"
              :on-exceed="handleExceed"
              :show-file-list="false"
              accept="image/*"
              :auto-upload="false"
            >
              <el-button
                slot="trigger"
                size="small"
                type="primary"
                class="chooseFile"
                ><img src="../img/camera.png" alt="" /> 选择文件</el-button
              >
              <div class="fileNameCon">
                <span v-if="picList.length == 0" class="fileName nofile"
                  >未选择任何文件</span
                >
                <span v-if="picList.length > 0" class="fileName">{{
                  picList[0].name
                }}</span>
              </div>
              
              <div class="imgTip">
                作品要求为jpg、JPEG、png、HEIC格式，文件大小不大于5MB。
              </div>
            </el-upload>
            <el-form-item
              size="small"
              label="描述"
              prop="desc"
              :rules="[
                {
                  min: 0,
                  max: 150,
                  message: '字数在150个字以内',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                type="textarea"
                v-model="singleForm.desc"
                :rows="5"
                autocomplete="off"
                placeholder="字数在150个字以内"
              ></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="footer">
            <el-button
              type="primary"
              class="submitBtn"
              v-on:click="submitPicInfo"
              >提交</el-button
            >
            <img
              src="../img/loading.gif"
              alt=""
              class="loading"
              v-show="loading"
            />
            <span class="closeBtn" @click="closeUpload">关闭</span>
          </span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "manage",
  components: {
    draggable,
  },
  data: function() {
    return {
      dialogVisible: false,
      id: "",
      loading: false,
      picList: [],
      infoForm: {
        title: "",
        user_name: "",
        cn: "",
        category_name: "",
        topic_name: "",
        desc: "",
        cover: "",
        photo_cover: [],
        photo_list: [],
      },
      singleForm: {
        desc: '',
        cover: []
      }
    };
  },
  created() {
    this.id = this.$route.query.id
    console.log("id=", this.id)
    if (this.id) {
      this.getInfo(this.id)
    }
  },
  methods: {
    add() {
      this.$message({
        message: "作品征集已截止",
        type: "warning",
      });
      return
      this.dialogVisible = true
      this.singleForm = {
        desc: '',
        cover: []
      }
    },
    // 设置封面
    setCover(item) {
      this.$message({
        message: "作品征集已截止",
        type: "warning",
      });
      return
      if(item.is_cover) {
        return
      } else {
        this.$utils.postJson('/works/api/setPhotoCover', {
          works_id: this.id,
          photo_id: item.photo_id
        }).then(res => {
          if(res.code == 1000) {
            this.$message({
              message: "设置成功！",
              type: "success",
            })
            this.getInfo(this.id)
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            })
          }
        })
      }
    },
    picChange(file) {
      if (!/\.(jpg|JPG|JPEG|HEIC|png|heic)$/.test(file.name)) {
        alert("图片格式为jpg、JPEG、png、HEIC");
        this.picList = [];
      } else {
        if (file.size / 1024 > 15120) {
          alert("图片大小不能超过15M");
        } else {
          this.picList = [];
          this.picList.push(file);
        }
      }
    },
    submitPicInfo() {
      this.$message({
        message: "作品征集已截止",
        type: "warning",
      });
      return
      console.log(this.picList);
      let videoPicParam = new FormData();
      if (this.picList.length > 0 && this.picList[0]["raw"]) {
        videoPicParam.append(
          "images",
          this.picList[0].raw,
          this.picList[0].name
        );
        this.loading = true;
        this.$utils
          .postFile("/user/upload/create-images", videoPicParam)
          .then((res) => {
            if (res.code == 1000) {
              this.singleForm.cover[0] = res.data.url
              console.log(res)
              this.addPhoto()
            }
          });
      } else {
        this.$message({
          message: "请选择图片",
          type: "warning",
        });
      }
    },
    deletePhoto(photo_id) {
      this.$message({
        message: "作品征集已截止",
        type: "warning",
      });
      return
      this.$confirm('您确定要删除该图片以及描述吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$utils.postJson('/works/delPhoto', {
          photo_id
        }).then(res => {
          if(res.code == 1000) {
            this.$message({
              message: "删除成功！",
              type: "success",
            });
            this.getInfo(this.id)
          }else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        })
      })
    },
    addPhoto() {
      this.$message({
        message: "作品征集已截止",
        type: "warning",
      });
      return
      this.$utils.postJson('/works/api/addPhoto', {
        works_id: this.id,
        photo_cover: this.singleForm.cover,
        photo_desc: [this.singleForm.desc]
      }).then(res => {
        console.log(res)
        if(res.code == 1000) {
          this.$message({
            message: "保存成功！",
            type: "success",
          });
          this.loading = false
          this.getInfo(this.id)
          this.dialogVisible = false
        }else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      })
    },
    closeUpload() {
      this.dialogVisible = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    forceUpdate() {
      this.$forceUpdate()
    },
    // 拖拽结束
    dataDragEnd(a) {
      this.infoForm.photo_list[a.oldIndex].photo_sort = a.oldIndex;
      this.infoForm.photo_list[a.newIndex].photo_sort = a.newIndex;
    },
    // 提交
    submit() {
      this.$message({
        message: "作品征集已截止",
        type: "warning",
      });
      return
      var data = {
        works_id: this.id,
        photo_list: this.infoForm.photo_list,
      };
      this.$utils.postJson("/works/api/updatePhoto", data).then((res) => {
        if (res.code == 1000) {
          this.$message({
            message: "提交成功！",
            type: "success",
          });
          this.$router.push('submit')
        }
      });
    },
    handleExceed() {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    getInfo(id) {
      this.$utils
        .get("/works/getInfo", {
          works_id: id,
        })
        .then((res) => {
          let data = res.data;
          this.infoForm.works_id = data.works_id;
          this.infoForm.title = data.title;
          this.infoForm.desc = data.desc;
          this.infoForm.user_name = data.user_name;
          this.infoForm.cn = data.cn;
          this.infoForm.cover = data.cover;
          this.infoForm.category_name = data.category_name;
          this.infoForm.topic_name = data.topic_name;
          var newList = [];
          for (var i = 0; i < data.photo_list.length; i++) {
            data.photo_list[i].photo_sort = i;
            newList.push(data.photo_list[i])
          }
          this.infoForm.photo_list = newList;
          console.log(this.infoForm.photo_list)
        });
    },
    routerTo(path) {
      this.$router.push(path)
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.manage {
  width: 1200px;
  margin: 29px auto 50px;
  text-align: center;
  font-size: 20px;
  text-align: left;
  .navbar {
    font-size: 24px;
    color: #0b2ab0;
    span {
      cursor: pointer;
    }
  }
  .content {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 33px 0 0;
    margin-top: 20px;
    box-sizing: border-box;
    .info {
      padding: 0 33px 33px;
      .cover {
        width: 360px;
        height: 226px;
      }
      .right {
        width: 750px;
        margin-left: 21px;
        display: inline-block;
        vertical-align: top;
        height: 226px;
        .title {
          font-size: 36px;
          color: #282828;
          
        }
        .user,
        .country {
          font-size: 20px;
          color: #666;
          margin-top: 10px;
        }
        .desc {
          font-size: 18px;
          margin-top: 20px;
          width: 100%;
          line-height: 1.4;
          text-indent: 2em;
        }
      }
    }
    .wrapper {
      padding: 30px 33px;
      box-sizing: border-box;
      background-color: #efecf8;
      width: 100%;
    }
    .uploadCon {
      width: 1134px;
      height: 81px;
      line-height: 81px;
      background-color: #fff;
      box-sizing: border-box;
      border: 1px solid #ccc;
      text-align: center;
      font-size: 26px;
      color: #bac4d4;
      cursor: pointer;
      img {
        width: 50px;
        margin-top: 17px;
        vertical-align: top;
        margin-right: 15px;
      }
    }
    .list {
      .photoCon {
        margin-top: 29px;
        position: relative;
        img {
          width: 360px;
          height: 226px;
        }
        .settingCon {
          position: absolute;
          bottom: 12px;
          background-color: rgba(0,0,0,0.3);
          color: #fff;
          width: 105px;
          height: 30px;
          line-height: 30px;
          font-size: 16px;
          text-align: center;
          cursor: pointer;
          img {
            width: 16px;
            height: 16px;
            margin-bottom: -3px;
          }
        }
        
        .right {
          display: inline-block;
          width: 753px;
          height: 226px;
          vertical-align: top;
          margin-left: 20px;
          .title {
            font-size: 32px;
            color: #0b2ab0;
            margin-bottom: 15px;
            .delete {
              width: 20px;
              height: auto;
              float: right;
              cursor: pointer;
            }
          }
        }
      }
      .isCover {
        .settingCon {
          background-color: rgba(#9576ef, 0.8);
        }
      }
    }
  }
  .submitCon {
    background-color: #fff;
    padding: 30px 0;
    .submit {
      width: 1131px;
      height: 63px;
      background-color: #9576ef;
      text-align: center;
      line-height: 63px;
      color: #fff;
      margin: auto;
      cursor: pointer;
    }
  }
  .uploadDialog {
    .content {
      margin-top: 0;
      padding: 3px;
    }
    .title {
      color: #f64109;
      font-size: 18px;
    }
    .chooseFile {
      background-color: #fff;
      border: 1px solid #ccc;
      color: #666;
      vertical-align: middle;
      img {
        vertical-align: bottom;
        margin-right: 5px;
      }
    }
    .chooseFile:hover {
      border: 1px solid rgb(83, 51, 51);
    }
    .fileNameCon {
      display: inline-block;
      vertical-align: top;
    }
    .fileName {
      display: block;
      margin-left: 15px;
      color: #999;
      line-height: 1.2;
      margin-top: 5px;
      .name {
        display: inline-block;
        width: 140px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .nofile {
      margin-top: 10px;
    }
    .imgTip {
      font-size: 14px;
      color: #999;
      margin-left: 110px;
      margin-top: 24px;
      padding-bottom: 23px;
    }
    .uploadVideoPic,
    .uploadVideoContent {
      margin-top: 35px;
      .chooseFile {
        background-color: #fff;
        border: 1px solid #ccc;
        color: #666;
        vertical-align: middle;
        img {
          vertical-align: bottom;
          margin-right: 5px;
        }
      }
      .chooseFile:hover {
        border: 1px solid #999;
      }
      .fileName {
        margin-left: 15px;
        color: #999;
      }
      .imgTip {
        font-size: 14px;
        color: #999;
        margin-left: 110px;
        margin-top: 24px;
        padding-bottom: 43px;
        margin-bottom: 20px;
      }
    }
    .uploadVideoContent {
      margin-top: 35px;
    }
    .uploading {
      text-align: center;
      padding-bottom: 20px;
      .gif {
      }
    }
    .ruleForm {
      width: 560px;
      padding-bottom: 27px;
      margin: 20px auto 0;
    }
    .footer {
      display: block;
      width: 100%;
      height: 77px;
      background-color: #faf6f4;
      .submitBtn {
        background-color: #f8683b;
        border: 1px solid #dc8800;
        margin-top: 20px;
        margin-left: 25px;
      }
      .loading {
        vertical-align: top;
        margin-top: 25px;
        margin-left: 10px;
      }
      .closeBtn {
        margin-left: 15px;
        color: #999;
        cursor: pointer;
      }
    }
  }
}
</style>
